import { render, staticRenderFns } from "./ScreenFailModal.vue?vue&type=template&id=5e4e8696&"
import script from "./ScreenFailModal.vue?vue&type=script&lang=js&"
export * from "./ScreenFailModal.vue?vue&type=script&lang=js&"
import style0 from "./ScreenFailModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports